import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled", "data-id"]
const _hoisted_2 = { class: "order-item__image" }
const _hoisted_3 = { class: "order-item__articles" }
const _hoisted_4 = { class: "order-item__info" }
const _hoisted_5 = { class: "order-item__name" }
const _hoisted_6 = { class: "order-item__price" }
const _hoisted_7 = { class: "order-item__name" }
const _hoisted_8 = {
  key: 0,
  class: "order-item__price"
}
const _hoisted_9 = {
  key: 0,
  class: "order-item__edit"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { "aria-label": "-" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { "aria-label": "+" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "sr-only" }
const _hoisted_15 = { class: "sr-only" }

import { CartItem } from '@/types';
    import { CartItemType } from '@/enums';
    import ArticleImage from '@/components/ArticleImage.vue';
    import { CartStore } from '@/stores/cart';
    import { reactive, onMounted } from 'vue';
    import router from '@/router';
    import { useEmitter } from '@/composables/useEmitter';
    import {i18nTranslate} from "../functions";
    import { useI18n} from "vue-i18n";

    interface Props {
        item: CartItem;
        disabled: boolean,
        editable: boolean,
        curency: string
    }

    interface State {
        showEditActions: boolean;
    }

    /* Props */
    
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderItem',
  props: {
    item: null,
    disabled: { type: Boolean },
    editable: { type: Boolean },
    curency: null
  },
  setup(__props: any) {

const props = __props as {
        item: CartItem;
        disabled: boolean,
        editable: boolean,
        curency: string
    };

    /* imports */
    const cart = CartStore();
    const emitter = useEmitter();
    const { locale } = useI18n();
    
    /* interface */
    

    /* reactive */
    const state = reactive<State>({
        showEditActions: false,
    });

    /* Functions */
    const quantity = (quantity: number) => {
        return quantity > 1 ? `${quantity}x` : '';
    };

    const toggleEdit = () => {

        if (props.disabled || !props.editable) {
            state.showEditActions = false;
        } else {
            state.showEditActions = !state.showEditActions;
        }

        if (state.showEditActions) {
            emitter.emit('showEditActions', { id: props.item.id })
        }
    };

    const hideEdit = () => {
        state.showEditActions = false;
    }

    const increaseItem = (item: CartItem) => {
        if (item) {
            cart.increase(item);
        }
    };

    const dataId = (id: string) : string => {
        return `a-${id}`;
    }

    const decreaseItem = (item: CartItem) => {
        if (item && item.quantity > 1) {
            cart.decrease(item);
        }
    }

    const removeCartItem = (item: CartItem) => {
        if (item) {
            cart.remove(item);
        }
    };

    const changeCartItem = (item: CartItem) => {
        if (item) {
            hideEdit();
            router.push({
                name: 'editOrder',
                params: {
                    categoryName: item.categoryName, articleId: item.article.code, orderId: item.id
                }
            });
        }
    }

    onMounted(() => {
        emitter.on('onNavigate', hideEdit);
        emitter.on('showEditActions', (data: any) => {
            if (data.id !== props.item.id) {
                hideEdit();
            }
        })
    });



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["order-item", {editable: __props.editable}]),
    style: {"overflow":"hidden"},
    disabled: __props.disabled,
    "data-id": dataId(__props.item.id),
    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (toggleEdit()), ["prevent"])),
    onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (toggleEdit()), ["enter"])),
    tabindex: "0"
  }, [
    _createElementVNode("span", _hoisted_2, [
      (_openBlock(), _createBlock(ArticleImage, {
        url: __props.item.article.imageUrl,
        key: __props.item.article.imageUrl
      }, null, 8, ["url"]))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(quantity(__props.item.quantity)) + " " + _toDisplayString(_unref(i18nTranslate)(__props.item.article.i18n, "description", _unref(locale))), 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString((__props.item.article.price * __props.item.quantity)) + _toDisplayString(__props.curency), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.flatChoices, (choice) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "order-item__info order-item__info--small",
          key: choice.id
        }, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(quantity(__props.item.quantity)) + " " + _toDisplayString(_unref(i18nTranslate)(choice.article.i18n, "description", _unref(locale))), 1),
          (choice.article.price > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString((choice.article.price * __props.item.quantity)) + _toDisplayString(__props.curency), 1))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createVNode(_Transition, { name: "from-right" }, {
      default: _withCtx(() => [
        (state.showEditActions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  class: "btn--link btn-decrease",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (decreaseItem(__props.item)), ["stop"]))
                }, _hoisted_11),
                _createElementVNode("span", null, _toDisplayString(__props.item.quantity), 1),
                _createElementVNode("button", {
                  class: "btn--link btn-increase",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (increaseItem(__props.item)), ["stop"]))
                }, _hoisted_13)
              ]),
              (__props.item.type == _unref(CartItemType).Article)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn--link btn-edit",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (changeCartItem(__props.item)), ["stop"]))
                  }, [
                    _createElementVNode("span", _hoisted_14, "Ändra " + _toDisplayString(_unref(i18nTranslate)(__props.item.article.i18n, "description", _unref(locale))), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn--link btn-remove",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (removeCartItem(__props.item)), ["stop"]))
              }, [
                _createElementVNode("span", _hoisted_15, "Ta bort " + _toDisplayString(_unref(i18nTranslate)(__props.item.article.i18n, "description", _unref(locale))), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (state.showEditActions)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "click-outside",
          onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (toggleEdit()), ["enter"]))
        }, null, 32))
      : _createCommentVNode("", true)
  ], 42, _hoisted_1))
}
}

})